/**
 * Check-in navigation helpers (feature: checkin-same-day-multi-event).
 *
 * Pure functions extracted so the Dashboard / Check-in routing decisions are
 * unit- and property-testable and kept out of the components.
 */

/**
 * Build the route to the check-in screen for a specific event.
 * Carrying the event id is what lets a user open a specific same-day event
 * instead of the auto-selected one.
 */
export function checkinPath(eventId: string): string {
  return `/checkin/${eventId}`;
}

/**
 * Resolve the effective event id the check-in screen should load.
 *
 * Only ADMINS may open a specific event by id (the past-event
 * attendance-edit path). For everyone else (coaches), the id is ignored and
 * the screen falls back to the backend's current/next auto-select — so a
 * coach on the Check-in screen always sees the current/upcoming event and can
 * never request a historical event (which the backend would reject with a 403
 * and log as an application error).
 *
 * @param routeEventId the `:eventId` route param, if any
 * @param isAdmin whether the current user is in the admin group
 * @returns the event id to load, or undefined to use current/next auto-select
 */
export function resolveEffectiveEventId(
  routeEventId?: string,
  isAdmin?: boolean,
): string | undefined {
  return isAdmin && routeEventId ? routeEventId : undefined;
}
